import IStepOneModel from './IStepOneModel';

const StepOneModelInitialState: IStepOneModel = {
  insurancePolicyNumber: null,
  holderNationalCodeNatural: null,
  loginUserIsBimehGozar: false,
};

export default StepOneModelInitialState;
